import styled from 'styled-components';

const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--primary-color);
  color: var(--background-color);
  padding: 8px 16px;
  text-decoration: none;
  z-index: 1000;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: top 0.2s ease;

  &:focus {
    top: 0;
  }
`;

export default SkipLink;
